import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getLocalizedPath } from '../i18nLanguages';

const getLocalizedTo = (to, pathname) => {
  if (typeof to === 'string') return getLocalizedPath(to, pathname);

  if (to && typeof to === 'object' && to.pathname) {
    return {
      ...to,
      pathname: getLocalizedPath(to.pathname, pathname),
    };
  }

  return to;
};

const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useCallback(
    (to, options) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      navigate(getLocalizedTo(to, pathname), options);
    },
    [navigate, pathname]
  );
};

export default useLocalizedNavigate;
